import React, { useState, useEffect } from "react";
import _ from "lodash";
import Chart from "react-apexcharts";
import Loading from "../common/loading";

const DashboardDial = ({ parameter, data }) => {
  const [options, setOptions] = useState({
    plotOptons: {
      radialBar: {
        hollow: {
          size: "70%",
        },
      },
    },
    labels: [],
  });
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(data)) {
      if (!data[parameter]) return console.log(parameter, "Not Found");
      setOptions({
        plotOptions: {
          radialBar: {
            hollow: {
              size: "75%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                offsetY: -10,
                show: true,
                color: "#888",
                fontSize: "13px",
              },
              value: {
                color: "#111",
                fontSize: "30px",
                show: true,
              },
            },
          },
        },
        stroke: { lineCap: "round" },
        fill: {
          colors: ["#65B32E"],
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 1,
            gradientToColors: ["#F1DE00"],
            stops: [0, 70],
          },
        },
        labels: [data[parameter] ? data[parameter].Name : ""],
      });
      setSeries(
        data[parameter].data.length > 0
          ? [
              data[parameter].data[0].PARAM_VALUE.toFixed(
                Math.min(data[parameter].Precision, 1)
              ),
            ]
          : [0]
      );
    }
  }, [parameter, data]);
  return (
    <div>
      {series.length === 0 ? (
        <Loading />
      ) : (
        <Chart options={options} series={series} type="radialBar" />
      )}
    </div>
  );
};

export default DashboardDial;
